<split-card theme="secondary">
  <ng-container card-header>
    <article
      class="invoice-card"
      [ngClass]="cardClasses"
      [attr.aria-label]="'Nota fiscal da venda ' + card.invoice.revenueId">

      <!-- ─── Header ──────────────────────────────────────────────────────── -->
      <header class="invoice-card__header">
        <div class="invoice-card__title">
          <span class="invoice-card__id">#{{ card.invoice.revenueId }}</span>
          <span class="invoice-card__date">
            {{ card.invoice.issueDate ? (card.invoice.issueDate | date:'dd/MM/yyyy') : '-' }}
          </span>
        </div>

        <app-invoice-status-badge [statusRule]="card.statusRule"></app-invoice-status-badge>
      </header>

      <!-- ─── Banners (config-driven, never check raw status here) ────────── -->
      <app-invoice-error-banner
        *ngIf="showErrorBanner"
        [message]="card.invoice.friendlyErrorMessage">
      </app-invoice-error-banner>

      <app-invoice-support-banner
        *ngIf="showSupportBanner"
        [invoiceId]="card.invoice.revenueId">
      </app-invoice-support-banner>

      <!-- ─── Body ────────────────────────────────────────────────────────── -->
      <section class="invoice-card__body" aria-label="Dados da nota fiscal">
        <div class="invoice-card__column">
          <span class="invoice-card__label">Emissor</span>
          <strong appCamelCaseText>{{ card.invoice.issuer.name }}</strong>
          <small>{{ card.invoice.issuer.registrationNumber | mask:'000.000.000-00||00.000.000/0000-00' }}</small>
        </div>

        <div class="invoice-card__column">
          <span class="invoice-card__label">Consumidor</span>
          <strong appCamelCaseText>{{ card.invoice.customer.name }}</strong>
          <small>{{ card.invoice.customer.taxId | mask:'000.000.000-00||00.000.000/0000-00' }}</small>
        </div>

        <div class="invoice-card__column invoice-card__details"
             [class.invoice-card__details--visible]="detailsVisible">
          <span class="invoice-card__label">Prestador / Serviço</span>
          <strong appCamelCaseText>{{ card.invoice.professionalName }}</strong>
          <small appCamelCaseText>{{ card.invoice.serviceName }}</small>
          <small appCamelCaseText>{{ card.invoice.specialtyName }}</small>
        </div>

        <div class="invoice-card__column invoice-card__column--amount invoice-card__details"
             [class.invoice-card__details--visible]="detailsVisible">
          <span class="invoice-card__label">Valor emitido</span>
          <strong class="invoice-card__amount-value">{{ card.invoice.issuer.amount | currency:'BRL' }}</strong>
          <small>Total da venda: {{ card.invoice.financial.grossAmount | currency:'BRL' }}</small>
        </div>
      </section>

      <!-- ─── Footer ──────────────────────────────────────────────────────── -->
      <footer class="invoice-card__footer">
        <button
          *ngIf="!hasBanner"
          type="button"
          class="invoice-card__toggle"
          (click)="toggleDetails()"
          [attr.aria-expanded]="detailsVisible">
          <span>{{ detailsVisible ? 'Ver menos' : 'Ver tudo' }}</span>
          <split-icon
            name="chevron-right"
            [classes]="detailsVisible ? 'invoice-card__toggle-icon invoice-card__toggle-icon--open' : 'invoice-card__toggle-icon'"
            size="14">
          </split-icon>
        </button>

        <app-invoice-action-buttons
          [actions]="card.actions"
          [visible]="detailsVisible"
          [loadingAction]="card.loadingAction"
          (actionSelected)="onActionSelected($event)">
        </app-invoice-action-buttons>
      </footer>
    </article>
  </ng-container>
</split-card>
